import React, { Component } from 'react';

/**
 * This is a static react port of the cdc template facebook logo svg
 */
export default class FacebookLogo extends Component {

    render() {
        return (
            <svg width="25" height="24" viewBox="0 0 320 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M279.14 288L293.36 195.34H204.45V135.21C204.45 109.86 216.87 85.15 256.69 85.15H297.11V6.26C297.11 6.26 260.43 0 225.36 0C152.14 0 104.28 44.38 104.28 124.72V195.34H22.8899V288H104.28V512H204.45V288H279.14Z" fill="white" />
            </svg>

        );
    }

}
